import { render, staticRenderFns } from "./ManagementColor.vue?vue&type=template&id=60428b06&scoped=true"
import script from "./ManagementColor.vue?vue&type=script&lang=js"
export * from "./ManagementColor.vue?vue&type=script&lang=js"
import style0 from "./ManagementColor.vue?vue&type=style&index=0&id=60428b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60428b06",
  null
  
)

export default component.exports